// 将4个模块请求的接口函数统一暴露
import * as dashboard from './dashboard/dashboard';
import * as modify from './modify/modify';
import * as usermanage from './usermanage/usermanage';
import * as goldcoins from './goldcoins/goldcoins';
import * as level from './level/level';
import * as admin from './system/admin';
import * as power from './system/power';
import * as handleJournal from './system/handleJournal';
import * as loginJournal from './system/loginJournal';
import * as courseware from './courseware/courseware';
import * as setting from './recharge/setting';

// 对外暴露
export default {
    dashboard,
    modify,
    usermanage,
    goldcoins,
    level,
    admin,
    power,
    handleJournal,
    loginJournal,
    courseware,
    setting
}